<mat-progress-spinner *ngIf="fetching" [strokeWidth]="5" [diameter]="50"
                      style="margin: 38% auto;"
                      mode="indeterminate"></mat-progress-spinner>
<p *ngIf="noData" style="margin: 30%; text-align: center;">No post was found.</p>
